import { useGetTeamBlocksBillingQuery } from 'store/apis/teamsApi';
import {
  parseUser,
  StatusLabels,
} from 'components/TeamOverview/BillingSection/utilities/utilities';
import { useQueryError } from 'utilities/hooks/useQueryError/useQueryError';
import { FETCH_TEAMS_BLOCK_BILLING_ERROR } from 'constants/errorMessages';

export const useTeamBlocksBilling = (team) => {
  const {
    data,
    error,
    isFetching: isLoading,
  } = useGetTeamBlocksBillingQuery(
    {
      teamUUID: team?.uuid,
    },
    {
      skip: !team?.uuid,
    },
  );

  useQueryError(error, FETCH_TEAMS_BLOCK_BILLING_ERROR);

  const parsedBlocksBilling = data
    ? data.map((blocksBilling) => {
      const {
        project,
        order,
        status,
        submitted_user,
        block_count,
        fulfilled_date,
        next_billing_date,
      } = blocksBilling;

      return {
        project,
        orderId: order.id,
        orderUUID: order.uuid,
        statusLabel: StatusLabels[status],
        user: parseUser(submitted_user),
        blocksCount: block_count,
        status,
        fulfilledDate: fulfilled_date,
        nextBillingDate: next_billing_date,
      };
    })
    : [];

  return {
    blocksBillings: parsedBlocksBilling,
    isLoading,
  };
};
